import type { Ref } from 'vue'
import { computed, ref, toRef } from 'vue'
import type { ThreeSixtyFragment } from '@/graphql/api'

export function useThreeSixtyImages(
    images: Readonly<Ref<ThreeSixtyFragment[]>>
) {
    const imageCount = toRef(images.value.length)

    const _currentImageIndex = ref(0)
    const currentImageIndex = computed({
        get: () => _currentImageIndex.value,
        set: (value) => {
            if (value < 0) {
                let v = imageCount.value + (value % imageCount.value)

                if (v === imageCount.value) {
                    v = 0
                }
                _currentImageIndex.value = v
            } else if (value > imageCount.value - 1) {
                _currentImageIndex.value = value % imageCount.value
            } else {
                _currentImageIndex.value = value
            }
        },
    })

    return {
        currentImageIndex,
    }
}
